import { createStrictContext } from 'utils/createContext'
import {
  useCasDispositionTypesQuery,
  useEditCasDispositionTypeMutation,
} from 'schema'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { useGlobalState } from 'context/GlobalStateContext'
import { CASDispositionTypeContext } from './types'
import { simpleEditNotification } from 'hooks/notificationHandler'

const { Provider, useContextFn } =
  createStrictContext<CASDispositionTypeContext>('DispositionTypesContext')

export const useDispositionTypesContext = useContextFn

const DispositionTypesProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, loading, refetch } = useCasDispositionTypesQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const [editFn] = useEditCasDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editCASDispositionType: {
        dispositionType: { name },
      },
    }) => simpleEditNotification(name),
  })
  return (
    <Provider
      value={{
        loading,
        refetch,
        dispositionTypes: data?.casDispositionTypes?.records ?? [],
        edit: async (input) => {
          await editFn({ variables: { input } })
        },
      }}
    >
      {children}
    </Provider>
  )
}

export default DispositionTypesProvider
